var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9044 6.00514C14.8349 9.38817 13.0582 11.4961 8.99998 11.4961C4.94178 11.4961 3.16506 9.38817 1.09558 6.00514C3.16506 2.62211 4.94178 0.514137 8.99998 0.514137C13.0582 0.514137 14.8349 2.62211 16.9044 6.00514Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00004 8.48328C10.3437 8.48328 11.4329 7.37378 11.4329 6.00513C11.4329 4.63649 10.3437 3.52699 9.00004 3.52699C7.65638 3.52699 6.56714 4.63649 6.56714 6.00513C6.56714 7.37378 7.65638 8.48328 9.00004 8.48328Z",
    stroke: "white",
    strokeWidth: 0.7,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view_icon.807e495ec801e3947bd7c2f0b019ec7d.svg";
export { ForwardRef as ReactComponent };